(function () {
    var $searchForm = $('.job-search-form');
    var ccm_token = $('#ccm_token');
    var type_of_childcare = $('#type_of_childcare');
    var qualification = $('#qualification');
    var city = $('#city');
    var employment_type = $('#employment_type');
    var employment_term = $('#employment_term');
    var keyword = $('#keyword');
    var clear = $('#clear');

    $searchForm.on('change', '.search-field', function () {
        doSearch();
    });

    $searchForm.on('submit', function(e) {
        e.preventDefault();
        doSearch();
    });

    keyword.on('blur', function() {
        doSearch();
    });

    clear.on('click', function() {
        $searchForm.trigger('reset');
        doSearch();
    });

    var doSearch = function() {
        $.post('/api/v1/job-posts/search',
            {
                ccm_token: ccm_token.val(),
                type_of_childcare: type_of_childcare.val(),
                qualification: qualification.val(),
                city: city.val(),
                employment_type: employment_type.val(),
                employment_term: employment_term.val(),
                keyword: keyword.val()
            },
            function (data, status) {
                $('#search-results').html(data);
            }
        );
    }
})();